import responses from './responses';

export default responses;
